import styled from 'styled-components';

export const SFooter = styled.div`
    min-height: 3rem;
`;
